import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import logoSplash from '../../../assets/logo.png';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(10, 81, 75, 0.4);
  }
  70% {
    box-shadow: 0 0 0 20px rgba(10, 81, 75, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(10, 81, 75, 0);
  }
`;

const SplashContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100dvh;
  background: linear-gradient(135deg, #0a514b 0%, #063834 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 150vw;
    height: 150vw;
    background: radial-gradient(circle, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0) 60%);
    pointer-events: none;
  }
`;

const LogoWrapper = styled(motion.div)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 20px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  animation: ${pulse} 2s infinite;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
`;

const SplashLogo = styled.img`
  width: 60vw;
  max-width: 200px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 0 10px rgba(255,255,255,0.2));
  
  @media (orientation: landscape) and (max-height: 500px) {
    width: auto;
    height: 60vh;
    max-height: 150px;
  }
`;

const LoadingText = styled(motion.p)`
  margin-top: 40px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-family: 'Inter', sans-serif;
`;

const SplashScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 2800); // Slightly longer for the animation to play out nicely

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <SplashContainer>
      <LogoWrapper
        initial={{ opacity: 0, scale: 0.8, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1],
          delay: 0.2
        }}
      >
        <SplashLogo src={logoSplash} alt="NYBANQ Logo" />
      </LogoWrapper>

      <LoadingText
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          duration: 0.6,
          delay: 1,
          ease: "easeOut"
        }}
      >
        Iniciando...
      </LoadingText>
    </SplashContainer>
  );
};

export default SplashScreen;